import React, { useEffect, useState, Suspense, lazy } from "react";
import Header from "../Header/index";
import HeroSection from "../HeroSection/index";
import ScrollToTop from "../ScrollToTop/index";
import fallbackData from "./data.json";
import "./MainPage.css";

const BruceSection = lazy(() => import("../BruceSection/index"));
const SlideSection = lazy(() => import("../SlideSection/index"));
const ArbitrageSection = lazy(() => import("../ArbitrageSection/index"));
const MarketStats = lazy(() => import("../MarketStats/index"));
const HeadstartSection = lazy(() => import("../HeadstartSection/index"));
const TokenizationSection = lazy(() => import("../TokenizationSection/index"));
const AnnouncementSection = lazy(() => import("../AnnouncementSection/index"));
const NothingBeyondReach = lazy(() => import("../NothingBeyondReach/index"));
const NbrCarousel = lazy(() => import("../NbrCarousel/index"));
const SearchBar = lazy(() => import("../AngelaiMessagebar/searchbar"));
const Disclaimers = lazy(() => import("../Disclaimers/index"));
const Footer = lazy(() => import("../CellFooter/index"));

export default function MainPage() {
  const [data, setData] = useState(fallbackData);
  const [showBelowFold, setShowBelowFold] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_IMAGES}data.json?v=${Date.now()}`);
        if (res.ok) {
          const json = await res.json();
          setData(json);
        }
      } catch (e) {}
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (window.innerHeight > 1000) {
      setShowBelowFold(true);
      return;
    }
    const handleScroll = () => setShowBelowFold(true);
    window.addEventListener("scroll", handleScroll, { passive: true, once: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <main className="angel-rewards-page">
      <Header />
      <HeroSection data={data.heroSection} />
      <ScrollToTop />
      <Suspense fallback={<div style={{ minHeight: "400px" }} />}>
        <BruceSection data={data.bruceSection} />
      </Suspense>
      <Suspense fallback={<div style={{ minHeight: "400px" }} />}>
        {data.slidesGroup1 && data.slidesGroup1.map((slide) => (
          <SlideSection key={slide.id} data={slide} />
        ))}
      </Suspense>
      <Suspense fallback={<div style={{ minHeight: "400px" }} />}>
        <ArbitrageSection data={data.arbitrageSection} />
      </Suspense>
      {showBelowFold && (
        <>
          <Suspense fallback={<div style={{ minHeight: "400px" }} />}>
            {data.slidesGroup2 && data.slidesGroup2.map((slide) => (
              <SlideSection key={slide.id} data={slide} />
            ))}
          </Suspense>
          <Suspense fallback={<div style={{ minHeight: "600px" }} />}>
            <HeadstartSection data={data.headstartSection} />
          </Suspense>
          <Suspense fallback={<div style={{ minHeight: "400px" }} />}>
            {data.slidesGroup3 && data.slidesGroup3.map((slide) => (
              <SlideSection key={slide.id} data={slide} />
            ))}
          </Suspense>
          <Suspense fallback={<div style={{ minHeight: "400px" }} />}>
            <TokenizationSection data={data.tokenizationSection} />
          </Suspense>
          <Suspense fallback={<div style={{ minHeight: "400px" }} />}>
            {data.slidesGroup4 && data.slidesGroup4.map((slide) => (
              <SlideSection key={slide.id} data={slide} />
            ))}
          </Suspense>
          <Suspense fallback={<div style={{ minHeight: "200px" }} />}>
            <MarketStats data={data.marketStats2} />
          </Suspense>
          <Suspense fallback={<div style={{ minHeight: "400px" }} />}>
            {data.slidesGroup5 && data.slidesGroup5.map((slide) => (
              <SlideSection key={slide.id} data={slide} />
            ))}
          </Suspense>
          <Suspense fallback={<div style={{ minHeight: "600px" }} />}>
            <AnnouncementSection data={data.announcementSection} />
          </Suspense>
          <Suspense fallback={<div style={{ minHeight: "400px" }} />}>
            <NothingBeyondReach data={data.nothingBeyondReach} />
          </Suspense>
          <Suspense fallback={<div style={{ minHeight: "200px" }} />}>
            <NbrCarousel data={data.nbrCarousel} />
          </Suspense>
          <Suspense fallback={<div style={{ minHeight: "200px" }} />}>
            <SearchBar data={data.searchBar} />
          </Suspense>
          <Suspense fallback={<div style={{ minHeight: "100px" }} />}>
            <Disclaimers data={data} />
          </Suspense>
          <Suspense fallback={<div style={{ minHeight: "300px" }} />}>
            <Footer />
          </Suspense>
        </>
      )}
    </main>
  );
}
